<template>
  <div class="home">
    <div id="el-one" class="el-card card-style" style="display: flex; justify-content: center;align-items: center;
      width: 220px;height: 210px;border: 1px solid gainsboro;" @click="goToDeviceManagement(0)">
      <div class="JGHD"><el-button id="wl-button"></el-button></div>
    </div>

    <div id="el-two" class="el-card card-style" style="display: flex; justify-content: center;align-items: center;
      width: 220px;height: 210px;border: 1px solid gainsboro;" @click="goToDeviceManagement(1)">
      <div class="FZYC"><el-button id="wl-button"></el-button></div>
    </div>

    <div id="el-three" class="el-card card-style" style="display: flex; justify-content: center;align-items: center;
      width: 220px;height: 210px;border: 1px solid gainsboro;" @click="goToDeviceManagement(2)">
      <div class="DSFZ"><el-button id="ds-button"></el-button></div>
    </div>

    <div id="el-four" class="el-card card-style" style="display: flex; justify-content: center;align-items: center;
      width: 220px;height: 210px;border: 1px solid gainsboro;" @click="goToDeviceManagement(3)">
      <div class="JRZJ"><el-button id="wl-button"></el-button></div>
    </div>

    <div id="el-five" class="el-card card-style" style="display: flex; justify-content: center;align-items: center;
      width: 220px;height: 210px;border: 1px solid gainsboro;" @click="goToDeviceManagement(4)">
      <div class="HLSW"><el-button id="wl-button"></el-button></div>
    </div>

    <div id="el-six" class="el-card card-style" style="display: flex; justify-content: center;align-items: center;
      width: 220px;height: 210px;border: 1px solid gainsboro;" @click="goToDeviceManagement(5)">
      <div class="HFNMKJ"><el-button id="wl-button"></el-button></div>
    </div>

    <div id="el-seven" class="el-card card-style" style="display: flex; justify-content: center;align-items: center;
      width: 220px;height: 210px;border: 1px solid gainsboro;" @click="goToDeviceManagement(6)">
      <div class="SJJY"><el-button id="wl-button"></el-button></div>
    </div>

    <div id="el-eight" class="el-card card-style" style="display: flex; justify-content: center;align-items: center;
      width: 220px;height: 210px;border: 1px solid gainsboro;" @click="goToDeviceManagement(7)">
      <div class="HFBH"><el-button id="wl-button"></el-button></div>
    </div>

    <div id="el-nine" class="el-card card-style" style="display: flex; justify-content: center;align-items: center;
      width: 220px;height: 210px;border: 1px solid gainsboro;" @click="goToDeviceManagement(8)">
      <div class="GHZY"><el-button id="wl-button"></el-button></div>
    </div>

    <div id="el-ten" class="el-card card-style" style="display: flex; justify-content: center;align-items: center;
      width: 220px;height: 210px;border: 1px solid gainsboro;" @click="goToDeviceManagement(9)">
      <div class="JPJB"><el-button id="wl-button"></el-button></div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import index from "vuex";

export default {
  data() {
    return {
      company_names: [], // 存储公司名称的数组
      company_ids: [], // 存储公司ID的数组
      name: "Home",
    }
  },
  mounted() {
    this.fetchCompanyName(); // 在组件挂载后调用异步请求函数
  },
  methods: {
    // 从后端获取企业id 和 企业名称
    fetchCompanyName() {
      // 发送异步请求获取后端数据
      axios.get('/otherApi/manager/getallcompany/')
        .then(res => {
          console.log(res)
          // 从返回的数据中获取公司名称，并保存到组件的数据中
          /*this.company_name = res.data.data[0].company_name;
          this.company_id = res.data.data[0].company_id;*/
          // 从返回的数据中获取公司名称和ID，并保存到组件的数据中
          this.company_names = res.data.data.map(company => company.company_name);
          this.company_ids = res.data.data.map(company => company.company_id);
        })
        .catch(error => {
          console.error('Error fetching company name:', error);
        });
    },
    // 根据企业id 去查到 企业id相关的设备表面参数
    goToDeviceManagement(index) {
      if (this.company_ids.length === 0 || index >= this.company_ids.length) {
        console.error('没有该企业!');
        return "没有这个企业id";
      }
      const company_id = this.company_ids[index];

      console.log('company_id =======' + company_id)
      this.$router.push({
        path:'/menu/card', // 路径
        query:{ company_id : company_id }, //查询参数
      })
      // 发送异步请求获取后端数据
      axios.get('/otherApi/manager/getallcompanysensor/',{
        params:{
          company_id : company_id,
        }
      }).then(res => {
          console.log(res)
          if (this.$route.path !== '/menu/card') {
            this.$router.push({path:'/menu/card',query:res.data.data});
          }
        })
        .catch(error => {
          console.error('Error fetching company id:', error);
        });
      },
  }
}
</script>

<style scoped>
.home{
  position: absolute;
  top: 60px;
  left: 300px;
}
.el-card {
  position: absolute;
  top: 110px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 220px;
  height: 210px;
  border: 2px solid #e0e0e0;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.el-card:hover{
  border-color: #bfbfbf;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.25);
}
#el-two{
  position: absolute;
  top: 110px;
  left: 300px;
}
#el-three{
  position: absolute;
  top: 110px;
  left: 600px;
}
#el-four{
  position: absolute;
  top: 110px;
  left: 900px;
}
#el-five{
  position: absolute;
  top: 360px;
  left: 0px;
}
#el-six{
  position: absolute;
  top: 360px;
  left: 300px;
}
#el-seven{
  position: absolute;
  top: 360px;
  left: 600px;
}
#el-eight{
  position: absolute;
  top: 360px;
  left: 900px;
}
#el-nine{
  position: absolute;
  top: 610px;
  left: 0px;
}
#el-ten{
    position: absolute;
    top: 610px;
    left: 300px;
}
#ds-button{
  width: 80px;
  height: 80px;
  opacity: 0;
  margin-left: -8px;
  margin-top: -5px;
}
.DSFZ{
  background-image: url("https://hpc.cnhopo.com/hpcimgs/20240809_5460fe40_img_16.png");
  background-size: 280px;
  width: 300px;
  height: 600px;
  background-repeat: no-repeat;
  position: absolute;
  top: 10px;
  left: -28px;
  cursor: pointer;
}
.HLSW{
  background-image: url("https://hpc.cnhopo.com/hpcimgs/20250922_fe84b8f8_华兰生物logo.png");
  background-size: 230px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: -10px;
  left: 0px;
  cursor: pointer;
}
.JRZJ{
  background-image: url("https://hpc.cnhopo.com/hpcimgs/20250707_b9a5a2ac_JRZJ.jpg");
  background-size: 375px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0px;
  left: -6px;
  cursor: pointer;
}
.JPJB{
  background-image: url("../assets/img/img_17.png");
  background-size: 240px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: 15px;
  left: -10px;
  cursor: pointer;
}
.GHZY{
  background-image: url("../assets/img/img_23.png");
  background-size: 240px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: 36px;
  left: 0px;
  cursor: pointer;
}
.HFNMKJ{
  background-image: url("../assets/img/img_24.png");
  background-size: 210px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: 35px;
  left: 0px;
  cursor: pointer;
}
.SJJY{
  background-image: url("../assets/img/img_25.png");
  background-size: 280px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: 20px;
  left: -20px;
  cursor: pointer;
}
.HFBH{
  background-image: url("../assets/img/img_26.png");
  background-size: 170px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: 18px;
  left: 25px;
  cursor: pointer;
}
.FZYC{
  background-image: url("../assets/img/img_27.png");
  background-size: 400px;
  width: 220px;
  height: 220px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0px;
  left: -1px;
  cursor: pointer;
}
.JGHD{
  background-image: url("../assets/img/JGHD.png");
  background-size: 220px;
  width: 220px;
  height: 320px;
  background-repeat: no-repeat;
  position: absolute;
  top: -30px;
  left: 0px;
  cursor: pointer;
}
#wl-button{
  width: 80px;
  height: 80px;
  opacity: 0;
  margin-left: -8px;
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue